class ReviewInStore {
  constructor() {
    this.apiBase = '/apps/review-in-store';

    this.button = document.getElementById('reviewInStoreBtn');
    this.dialog = document.getElementById('reviewInStoreDialog');
    this.content = document.getElementById('reviewInStoreContent');

    this.productId = null;
    this.context = null;
    this.availability = null;
    this.selectedDate = null;
    this.selectedSlot = null;
    this.appointment = null;

    if (!this.button || !this.dialog || !this.content) return;

    this.button.addEventListener('click', () => this.open());

    this.dialog.addEventListener('close', () => {
      document.body.classList.remove('ris-modal-open');
    });

    this.dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      this.close();
    });

    this.dialog.addEventListener('click', (event) => {
      const rect = this.dialog.getBoundingClientRect();

      const clickedOutside =
        event.clientX < rect.left ||
        event.clientX > rect.right ||
        event.clientY < rect.top ||
        event.clientY > rect.bottom;

      if (clickedOutside) this.close();
    });
  }

  async open() {
    this.productId = this.button.dataset.productId;
    this.selectedDate = null;
    this.selectedSlot = null;
    this.appointment = null;

    this.showDialog();
    this.renderLoading();

    try {
      this.context = await this.request(
        `/review-in-store/product-context?product_id=${encodeURIComponent(this.productId)}`
      );

      if (!this.context.eligible) {
        this.renderUnavailable();
        return;
      }

      await this.loadAvailability();
      this.renderStep1();
    } catch (error) {
      this.renderError(error);
    }
  }

  showDialog() {
    document.body.classList.add('ris-modal-open');

    if (typeof this.dialog.showModal === 'function') {
      if (!this.dialog.open) this.dialog.showModal();
    } else {
      this.dialog.setAttribute('open', '');
    }
  }

  close() {
    document.body.classList.remove('ris-modal-open');

    if (this.dialog.open && typeof this.dialog.close === 'function') {
      this.dialog.close();
    } else {
      this.dialog.removeAttribute('open');
    }
  }

  async request(path, options = {}) {
    const response = await fetch(`${this.apiBase}${path}`, {
      ...options,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...(options.headers || {})
      }
    });

    const json = await response.json().catch(() => null);

    if (!response.ok || !json || json.message === 'error') {
      throw json || { message: 'Request failed' };
    }

    return json.data;
  }

  async loadAvailability() {
    const showroomId = this.context.default_showroom.id;

    this.availability = await this.request(
      `/review-in-store/showrooms/${showroomId}/availability?days=14`
    );
  }

  renderShell(html) {
    this.content.innerHTML = `
      <button type="button" class="ris-close" aria-label="Close">&times;</button>
      ${html}
    `;

    this.content.querySelector('.ris-close').addEventListener('click', () => {
      this.close();
    });
  }

  renderLoading() {
    this.renderShell(`
      <h2 class="ris-page-title">Store Booking Review</h2>
      <div class="ris-card ris-loading">Loading available showroom slots...</div>
    `);
  }

  renderUnavailable() {
    this.renderShell(`
      <h2 class="ris-page-title">Review in Store</h2>
      ${this.productCard()}
      <div class="ris-card">
        <h3>Not available</h3>
        <p>This product is not available for review in store.</p>
      </div>
    `);
  }

  renderError(error) {
    const message =
      error?.data?.errors?.[0] ||
      error?.message ||
      'Something went wrong. Please try again.';

    this.renderShell(`
      <h2 class="ris-page-title">Review in Store</h2>
      <div class="ris-card ris-error">
        ${message}
      </div>
    `);
  }

  productCard() {
    const product = this.context?.product || {};

    return `
      <div class="ris-product-card">
        <img src="${this.escape(product.image_url || '')}" alt="${this.escape(product.title || '')}">
        <div>
          <div class="ris-muted">Review in Store</div>
          <strong>${this.escape(product.title || '')}</strong>
        </div>
      </div>
    `;
  }

  showroomHeader() {
    const showroom = this.context.default_showroom;

    return `
      <div class="ris-showroom">
        <h2>${this.escape(showroom.name)}</h2>

        <div class="ris-showroom-actions">
          <span class="ris-open">✓ Open</span>

          ${
            showroom.map_url
              ? `<a class="ris-map" href="${this.escape(showroom.map_url)}" target="_blank" rel="noopener">Open in Maps</a>`
              : ''
          }
        </div>
      </div>
    `;
  }


  getShowroomMapHtml() {
  const showroom = this.context.default_showroom;

  const mapSrc =
    showroom.latitude && showroom.longitude
      ? `https://maps.google.com/maps?q=${showroom.latitude},${showroom.longitude}&z=14&output=embed`
      : '';

  return `
    <div class="ris-map-panel">
      <h3>${this.escape(showroom.name || 'Showroom')}</h3>
      <p>${this.escape(showroom.address || '')}</p>

      ${
        mapSrc
          ? `<iframe class="ris-map-frame" src="${mapSrc}" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`
          : ''
      }

      ${
        showroom.map_url
          ? `<a class="ris-map-link" href="${this.escape(showroom.map_url)}" target="_blank" rel="noopener">Open in Google Maps</a>`
          : ''
      }
    </div>
  `;
}
renderStep1() {
  const days = this.availability.days.filter((day) => {
    return day.has_slots && !day.is_closed;
  });

  this.renderShell(`
    <h2 class="ris-page-title">Store Booking Review</h2>

    <div class="ris-step-one-layout">
      <div class="ris-step-one-main" id="risStepOneMain"></div>

      ${this.getShowroomMapHtml()}
    </div>
  `);

  this.renderStep1Main(days);
}

renderStep1Main(days) {
  const container = this.content.querySelector('#risStepOneMain');

  const selectedDay = days.find((day) => day.date === this.selectedDate);
  const slots = (selectedDay?.slots || []).filter((slot) => !slot.booked && !slot.is_booked);

  container.innerHTML = `
    <p class="ris-intro-text">
      Please select a convenient date and time for your upcoming visit,
      ensuring it fits well with the store schedule!
    </p>

    <div class="ris-date-grid ris-date-grid-compact">
      ${days.slice(0, 8).map((day) => `
        <button
          type="button"
          class="ris-date ${this.selectedDate === day.date ? 'is-active' : ''}"
          data-date="${this.escape(day.date)}"
        >
          <small>${this.formatWeekday(day.date)}</small>
          <strong>${this.formatDate(day.date)}</strong>
          <small>${day.slots.length} Slots</small>
        </button>
      `).join('')}
    </div>

    <div class="ris-slot-section">
      <p class="ris-intro-text ris-slot-hint">
        Select available slot that suits you. The booking is auto-assigned to a free designer.
      </p>

      <div class="ris-slot-pills">
        ${
          this.selectedDate
            ? slots.slice(0, 4).map((slot) => `
              <button
                type="button"
                class="ris-slot-pill ${this.selectedSlot?.starts_at === slot.starts_at ? 'is-active' : ''}"
                data-start="${this.escape(slot.starts_at)}"
              >
                ${this.formatTime(slot.starts_at)}
              </button>
            `).join('')
            : `<div class="ris-empty-message">Please select a date first.</div>`
        }
      </div>
    </div>

    <button type="button" class="ris-primary ris-compact-next" id="risNextSlot" ${!this.selectedSlot ? 'disabled' : ''}>
      Next Step
    </button>
  `;

  container.querySelectorAll('.ris-date').forEach((button) => {
    button.addEventListener('click', () => {
      this.selectedDate = button.dataset.date;
      this.selectedSlot = null;
      this.renderStep1Main(days);
    });
  });

  container.querySelectorAll('.ris-slot-pill').forEach((button) => {
    button.addEventListener('click', () => {
      this.selectedSlot = slots.find((slot) => slot.starts_at === button.dataset.start);
      this.renderStep1Main(days);
    });
  });

  container.querySelector('#risNextSlot')?.addEventListener('click', () => {
    this.renderStep3();
  });
}

formatTime(date) {
  return new Date(date).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit'
  });
}

  renderStep2() {
    const day = this.availability.days.find((item) => item.date === this.selectedDate);
    const slots = (day?.slots || []).filter((slot) => !slot.booked && !slot.is_booked);

    this.renderShell(`
      <h2 class="ris-page-title">Select Date & Time</h2>

      ${this.productCard()}

      <div class="ris-summary-card">
        <p>${this.formatFullDate(this.selectedDate)}</p>
      </div>

      <div class="ris-step">
        <div class="ris-step-head">
          <h3>Step 2</h3>
          <span>Current</span>
        </div>

        <p>
          Select one of the available 2-hour slots.
          The booking is auto-assigned to a free designer.
        </p>

        <div class="ris-slot-list">
          ${slots.map((slot) => `
            <button
              type="button"
              class="ris-slot ${this.selectedSlot?.starts_at === slot.starts_at ? 'is-active' : ''}"
              data-start="${this.escape(slot.starts_at)}"
            >
              <span class="ris-clock">◷</span>

              <span>
                <strong>${this.formatTimeRange(slot.starts_at, slot.ends_at)}</strong>
                <small>${slot.available_designer_count} designer(s) free · auto-assigned at booking</small>
              </span>

              <b>✓</b>
            </button>
          `).join('')}
        </div>

        <div class="ris-actions">
          <button type="button" class="ris-secondary" id="risBackToDate">
            ← Back
          </button>

          <button type="button" class="ris-primary" id="risNextSlot" ${!this.selectedSlot ? 'disabled' : ''}>
            Next Step →
          </button>
        </div>
      </div>
    `);

    this.content.querySelectorAll('.ris-slot').forEach((button) => {
      button.addEventListener('click', () => {
        this.selectedSlot = slots.find((slot) => slot.starts_at === button.dataset.start);
        this.renderStep2();
      });
    });

    this.content.querySelector('#risBackToDate')?.addEventListener('click', () => {
      this.renderStep1();
    });

    this.content.querySelector('#risNextSlot')?.addEventListener('click', () => {
      this.renderStep3();
    });
  }

  renderStep3() {
    const customer = window.RIS_CUSTOMER || {};

    this.renderShell(`
      <h2 class="ris-page-title">Select Date & Time</h2>


      <div class="ris-step">
        <div class="ris-step-head">
          <h3>Step 3</h3>
          <span>Current</span>
        </div>

        <p>
          Confirm the required customer details.
          Filled profile fields are locked. Empty profile fields can still be completed here.
        </p>
        
        <div class="ris-summary-card">
          <p>${this.formatFullDate(this.selectedDate)} · ${this.formatTimeRange(this.selectedSlot.starts_at, this.selectedSlot.ends_at)}</p>
        </div>

        <form id="risBookingForm" class="ris-form">
          <label>
            <span>Client Name</span>
            <input
              name="customer_name"
              value="${this.escape(customer.name || '')}"
              ${customer.name ? 'readonly' : ''}
              required
            >
          </label>

          <label>
            <span>Client Email</span>
            <input
              name="customer_email"
              type="email"
              value="${this.escape(customer.email || '')}"
              ${customer.email ? 'readonly' : ''}
              required
            >
          </label>

          <label>
            <span>Client Phone</span>
            <input
              name="customer_phone"
              type="tel"
              value="${this.escape(customer.phone || '')}"
              required
            >
          </label>

          <label>
            <span>Notes optional</span>
            <textarea name="customer_notes"></textarea>
          </label>

          <div class="ris-actions ris-form-actions">
            <button type="button" class="ris-secondary" id="risBackToSlot">
              ← Back
            </button>

            <button type="submit" class="ris-primary">
              Confirm Booking
            </button>
          </div>
        </form>
      </div>
    `);

    this.content.querySelector('#risBackToSlot')?.addEventListener('click', () => {
      this.renderStep1();
    });

    this.content.querySelector('#risBookingForm').addEventListener('submit', async (event) => {
      event.preventDefault();
      await this.createAppointment(new FormData(event.target));
    });
  }

  async createAppointment(formData) {
    const submitButton = this.content.querySelector('.ris-primary[type="submit"]');
    submitButton.disabled = true;
    submitButton.textContent = 'Booking...';

    const body = {
      inventory_stock_id: this.context.default_showroom.id,
      product_id: this.productId,
      starts_at: this.selectedSlot.starts_at,
      customer_name: formData.get('customer_name'),
      customer_email: formData.get('customer_email'),
      customer_phone: formData.get('customer_phone'),
      customer_notes: formData.get('customer_notes'),
      source_channel: 'shopify'
    };

    try {
      this.appointment = await this.request('/review-in-store/appointments', {
        method: 'POST',
        body: JSON.stringify(body)
      });

      this.renderSuccess();
    } catch (error) {
      const message =
        error?.data?.errors?.[0] ||
        error?.message ||
        'Could not create booking.';

      alert(message);

      submitButton.disabled = false;
      submitButton.textContent = 'Confirm Booking';
    }
  }


renderSuccess() {
  const item = this.appointment;

  this.renderShell(`
    <h2 class="ris-page-title">Booking Success</h2>

    <div style="display:none" class="ris-success-icon">✓</div>

    <h2 style="display:none"  class="ris-success-title">Booking Confirmed</h2>

    <p class="ris-center">
      Your appointment is saved. Add it to your calendar so you do not miss it.
    </p>

    <div class="ris-card ris-booking-card">
      <div class="ris-step-head">
        <h3>Booking #${item.id}</h3>
        <span>${this.escape(item.status_label || item.status)}</span>
      </div>

      <div class="ris-details ris-booking-details">
        <p>
          <small>Date</small>
          <strong>${this.formatFullDate(item.starts_at)}</strong>
        </p>

        <p>
          <small>Time</small>
          <strong>${this.formatTimeRange(item.starts_at, item.ends_at)}</strong>
        </p>

        <p>
          <small>Showroom</small>
          <strong>${this.escape(item.showroom?.name || '')}</strong>
        </p>

        <p>
          <small>Address</small>
          <strong>${this.escape(item.showroom?.address || '')}</strong>
        </p>

        <p class="ris-detail-full">
          <small>Designer</small>
          <strong>${this.escape(item.designer?.name || 'Auto assigned')}</strong>
        </p>
      </div>
    </div>

    <div class="ris-product-card ris-success-product">
      <img src="${this.escape(item.product?.image_url || '')}" alt="${this.escape(item.product?.title || '')}">
      <div>
        <div class="ris-muted">Product</div>
        <strong>${this.escape(item.product?.title || '')}</strong>
        <div class="ris-muted">Reference: ${this.escape(item.product?.reference || '')}</div>
      </div>
    </div>

    <div class="ris-success-footer">
      <button type="button" class="ris-secondary ris-back-btn" id="risBackToProduct">
        ← Back to Product
      </button>

      <button type="button" class="ris-primary ris-calendar-main" id="risAddToCalendar">
        + Add to Calendar
      </button>
    </div>

    <div class="ris-calendar-options" id="risCalendarOptions" hidden>
      <button type="button" class="ris-calendar-option" id="risGoogleCalendar">
        <span class="ris-cal-icon">G</span>
        Google
      </button>

      <button type="button" class="ris-calendar-option" id="risOutlookWorkCalendar">
        <span class="ris-cal-icon">M</span>
        Outlook 365
      </button>

      <button type="button" class="ris-calendar-option" id="risOutlookPersonalCalendar">
        <span class="ris-cal-icon">O</span>
        Outlook.com
      </button>

      <button type="button" class="ris-calendar-option" id="risDownloadCalendar">
        <span class="ris-cal-icon">📅</span>
        Apple / Zoho / Other
      </button>
    </div>
  `);

  this.content.querySelector('#risAddToCalendar')?.addEventListener('click', () => {
    const options = this.content.querySelector('#risCalendarOptions');
    options.hidden = !options.hidden;
  });

  this.content.querySelector('#risGoogleCalendar')?.addEventListener('click', () => {
    window.open(this.buildGoogleCalendarUrl(item), '_blank');
  });

  this.content.querySelector('#risOutlookWorkCalendar')?.addEventListener('click', () => {
    window.open(this.buildOutlookCalendarUrl(item, 'work'), '_blank');
  });

  this.content.querySelector('#risOutlookPersonalCalendar')?.addEventListener('click', () => {
    window.open(this.buildOutlookCalendarUrl(item, 'personal'), '_blank');
  });

  this.content.querySelector('#risDownloadCalendar')?.addEventListener('click', () => {
    this.downloadIcsFile(item);
  });

  this.content.querySelector('#risDownloadCalendar')?.addEventListener('click', () => {
    this.downloadIcsFile(item);
  });

  this.content.querySelector('#risBackToProduct')?.addEventListener('click', () => {
    this.close();
  });
}
buildCalendarData(item) {
  const productTitle = item.product?.title || 'Product';
  const showroomName = item.showroom?.name || 'Showroom';
  const showroomAddress = item.showroom?.address || '';

  return {
    title: `Review in Store - ${productTitle}`,
    start: new Date(item.starts_at),
    end: new Date(item.ends_at),
    location: showroomAddress,
    description: [
      `Booking #${item.id}`,
      `Product: ${productTitle}`,
      `Showroom: ${showroomName}`,
      `Address: ${showroomAddress}`,
      `Designer: ${item.designer?.name || 'Auto assigned'}`
    ].join('\n')
  };
}

calendarUtcDate(date) {
  return date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
}

buildGoogleCalendarUrl(item) {
  const data = this.buildCalendarData(item);

  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: data.title,
    dates: `${this.calendarUtcDate(data.start)}/${this.calendarUtcDate(data.end)}`,
    details: data.description,
    location: data.location
  });

  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

buildOutlookCalendarUrl(item, type = 'work') {
  const data = this.buildCalendarData(item);

  const baseUrl =
    type === 'personal'
      ? 'https://outlook.live.com/calendar/0/deeplink/compose'
      : 'https://outlook.office.com/calendar/0/deeplink/compose';

  const params = new URLSearchParams({
    path: '/calendar/action/compose',
    rru: 'addevent',
    subject: data.title,
    startdt: data.start.toISOString(),
    enddt: data.end.toISOString(),
    body: data.description,
    location: data.location
  });

  return `${baseUrl}?${params.toString()}`;
}

downloadIcsFile(item) {
  const data = this.buildCalendarData(item);

  const escapeIcs = (value) => {
    return String(value || '')
      .replace(/\\/g, '\\\\')
      .replace(/;/g, '\\;')
      .replace(/,/g, '\\,')
      .replace(/\n/g, '\\n');
  };

  const icsContent = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Review In Store//Booking Calendar//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:review-in-store-${item.id}@shopify`,
    `DTSTAMP:${this.calendarUtcDate(new Date())}`,
    `DTSTART:${this.calendarUtcDate(data.start)}`,
    `DTEND:${this.calendarUtcDate(data.end)}`,
    `SUMMARY:${escapeIcs(data.title)}`,
    `DESCRIPTION:${escapeIcs(data.description)}`,
    `LOCATION:${escapeIcs(data.location)}`,
    'END:VEVENT',
    'END:VCALENDAR'
  ].join('\r\n');

  const blob = new Blob([icsContent], {
    type: 'text/calendar;charset=utf-8'
  });

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = `review-in-store-booking-${item.id}.ics`;
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

  formatWeekday(date) {
    return new Date(date).toLocaleDateString(undefined, {
      weekday: 'short'
    });
  }

  formatDate(date) {
    return new Date(date).toLocaleDateString(undefined, {
      day: 'numeric',
      month: 'short'
    });
  }

  formatFullDate(date) {
    return new Date(date).toLocaleDateString(undefined, {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  }

  formatTimeRange(start, end) {
    const options = {
      hour: 'numeric',
      minute: '2-digit'
    };

    return `${new Date(start).toLocaleTimeString([], options)} - ${new Date(end).toLocaleTimeString([], options)}`;
  }

  escape(value) {
    return String(value || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ReviewInStore();
});